import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  Signal,
} from '@angular/core';
import { ITariffSort } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { SortsGateway } from './sorts.gateway';

@Injectable({
  providedIn: 'root',
})
export class SortsStore {
  private readonly gateway: SortsGateway = new SortsGateway();

  #sortsResource: ResourceRef<IApiResponse<ITariffSort[]> | undefined> =
    resource({
      loader: () => {
        return firstValueFrom(this.gateway.list());
      },
    });

  public readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#sortsResource.isLoading()
  );
  public readonly sorts: Signal<ITariffSort[]> = computed((): ITariffSort[] =>
    this.#sortsResource.hasValue()
      ? (this.#sortsResource.value()?.data ?? [])
      : []
  );
  public reload(): void {
    this.#sortsResource.reload();
  }
}
